import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("jp_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Connexion impossible");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="font-display font-extrabold text-3xl text-cream tracking-tightest">Job<span className="text-terracotta">Propulse</span></div>
          <p className="text-cream/50 font-body mt-2">Espace administrateur</p>
        </div>
        <form onSubmit={submit} className="bg-cream rounded-3xl p-8 space-y-4" data-testid="admin-login-form">
          <div className="w-12 h-12 rounded-2xl bg-terracotta/10 flex items-center justify-center mb-2">
            <Lock className="w-5 h-5 text-terracotta" />
          </div>
          <div>
            <Label className="font-body text-sm text-ink">Email</Label>
            <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="mt-1.5 bg-white border-line" placeholder="admin@jobpropulse.fr" />
          </div>
          <div>
            <Label className="font-body text-sm text-ink">Mot de passe</Label>
            <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="mt-1.5 bg-white border-line" placeholder="••••••••" />
          </div>
          {error && <p className="text-destructive font-body text-sm" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-ink text-cream py-3.5 font-body font-semibold hover:bg-terracotta transition-colors disabled:opacity-60">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
